exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.datepicker .calendar {\n    color: #fff;\n    background: #333;\n    bottom:0;\n    left: 120px;\n}\n", ""]);

// exports
